import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonGroup } from 'core/elements';
import { ActionButtonType } from 'core/enums';
import { Color, Variant } from 'theme/enums';

import { QuotesDashboardDateRange } from './enums';

interface IProps {
  onChange: (dateRange: QuotesDashboardDateRange) => void;
  value: QuotesDashboardDateRange;
}

export const DateRangeFilter = ({ onChange, value }: IProps) => {
  const { t } = useTranslation();

  const getColor = useCallback(
    (type: QuotesDashboardDateRange) => (value === type ? Color.PRIMARY : Color.NEUTRAL),
    [value]
  );

  const buttons = useMemo(() => {
    return [
      {
        color: getColor(QuotesDashboardDateRange.MONTH_TO_DATE),
        label: t('buttonLabelMonthToDate'),
        onClick: () => onChange(QuotesDashboardDateRange.MONTH_TO_DATE),
        type: ActionButtonType.BUTTON,
        variant: Variant.OUTLINED,
      },
      {
        color: getColor(QuotesDashboardDateRange.YEAR_TO_DATE),
        label: t('buttonLabelYearToDate'),
        onClick: () => onChange(QuotesDashboardDateRange.YEAR_TO_DATE),
        type: ActionButtonType.BUTTON,
        variant: Variant.OUTLINED,
      },
      {
        color: getColor(QuotesDashboardDateRange.PREVIOUS_MONTH),
        label: t('buttonLabelPreviousMonth'),
        onClick: () => onChange(QuotesDashboardDateRange.PREVIOUS_MONTH),
        type: ActionButtonType.BUTTON,
        variant: Variant.OUTLINED,
      },
      {
        color: getColor(QuotesDashboardDateRange.PREVIOUS_YEAR),
        label: t('buttonLabelPreviousYear'),
        onClick: () => onChange(QuotesDashboardDateRange.PREVIOUS_YEAR),
        type: ActionButtonType.BUTTON,
        variant: Variant.OUTLINED,
      },
    ];
  }, [getColor, onChange, t]);

  return <ButtonGroup buttons={buttons} />;
};
